const cars = [
  {
    id: 1,
    name: "Lamborghini Aventador",
    price: "₹5 Cr",
    image: "https://images.unsplash.com/photo-1549924231-f129b911e442?w=800",
  },
  {
    id: 2,
    name: "Ferrari SF90",
    price: "₹7.5 Cr",
    image: "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?w=800",
  },
  {
    id: 4,
    name: "Audi R8",
    price: "₹2.3 Cr",
    image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800",
  },
  {
    id: 5,
    name: "Mercedes AMG GT",
    price: "₹2.7 Cr",
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800",
  },
  {
    id: 6,
    name: "Porsche 911",
    price: "₹1.8 Cr",
    image: "https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?w=800",
  },
  {
    id: 8,
    name: "Tesla Model X",
    price: "₹2 Cr",
    image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800",
  },
  {
    id: 9,
    name: "Rolls Royce Phantom",
    price: "₹9 Cr",
    image: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=800",
  },
  {
    id: 13,
    name: "Aston Martin DB11",
    price: "₹3.8 Cr",
    image: "https://images.unsplash.com/photo-1511919884226-fd3cad34687c?w=800",
  },
  {
    id: 14,
    name: "Jaguar F-Type",
    price: "₹1.2 Cr",
    image: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=800",
  },

  {
    id: 15,
    name: "Range Rover Sport",
    price: "₹1.8 Cr",
    image: "https://images.unsplash.com/photo-1541443131876-44b03de101c5?w=800",
  },
  {
    id: 16,
    name: "Toyota Land Cruiser",
    price: "₹2.1 Cr",
    image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=800",
  },
  {
    id: 17,
    name: "Ford Mustang",
    price: "₹90 Lakh",
    image: "https://images.unsplash.com/photo-1584345604476-8ec5e12e42dd?w=800",
  },
  {
    id: 18,
    name: "Chevrolet Camaro",
    price: "₹85 Lakh",
    image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800",
  },

  {
    id: 19,
    name: "Nissan GT-R",
    price: "₹2.1 Cr",
    image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800",
  },
  {
    id: 20,
    name: "Hyundai Ioniq 5",
    price: "₹45 Lakh",
    image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=800",
  },
  {
    id: 22,
    name: "Volvo XC90",
    price: "₹1 Cr",
    image: "https://images.unsplash.com/photo-1550355291-bbee04a92027?w=800",
  },

  {
    id: 23,
    name: "Skoda Superb",
    price: "₹40 Lakh",
    image: "https://images.unsplash.com/photo-1603386329225-868f9b1ee6c9?w=800",
  },
  {
    id: 24,
    name: "Volkswagen Passat",
    price: "₹35 Lakh",
    image: "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=800",
  },
  {
    id: 25,
    name: "Honda Civic",
    price: "₹20 Lakh",
    image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=800",
  },
  {
    id: 26,
    name: "Toyota Camry",
    price: "₹45 Lakh",
    image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800",
  },

  {
    id: 27,
    name: "Mahindra XUV700",
    price: "₹25 Lakh",
    image: "https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800",
  },
  {
    id: 28,
    name: "Tata Harrier",
    price: "₹20 Lakh",
    image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=800",
  },
  {
    id: 29,
    name: "MG Hector",
    price: "₹18 Lakh",
    image: "https://images.unsplash.com/photo-1603386329225-868f9b1ee6c9?w=800",
  },
  {
    id: 30,
    name: "Hyundai Creta",
    price: "₹17 Lakh",
    image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=800",
  },

  {
    id: 31,
    name: "Kia Seltos",
    price: "₹16 Lakh",
    image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800",
  },
  {
    id: 32,
    name: "Maruti Brezza",
    price: "₹12 Lakh",
    image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800",
  },
  {
    id: 33,
    name: "Renault Kiger",
    price: "₹10 Lakh",
    image: "https://images.unsplash.com/photo-1603386329225-868f9b1ee6c9?w=800",
  },
  {
    id: 34,
    name: "Nissan Magnite",
    price: "₹9 Lakh",
    image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800",
  },

  {
    id: 35,
    name: "Suzuki Swift",
    price: "₹8 Lakh",
    image: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?w=800",
  },
  {
    id: 36,
    name: "Hyundai i20",
    price: "₹9 Lakh",
    image: "https://images.unsplash.com/photo-1584345604476-8ec5e12e42dd?w=800",
  },
  {
    id: 37,
    name: "Tata Nexon",
    price: "₹14 Lakh",
    image: "https://images.unsplash.com/photo-1625047509168-a7026f36de04?w=800",
  },
  {
    id: 38,
    name: "Mahindra Thar",
    price: "₹16 Lakh",
    image: "https://images.unsplash.com/photo-1541443131876-44b03de101c5?w=800",
  },

  {
    id: 39,
    name: "Jeep Compass",
    price: "₹28 Lakh",
    image: "https://images.unsplash.com/photo-1550355291-bbee04a92027?w=800",
  },
  {
    id: 40,
    name: "Toyota Fortuner",
    price: "₹45 Lakh",
    image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=800",
  },
];

export default cars;
